export default __webpack_public_path__ + "static/media/lightswitch_double_00.a8946c9d.svg";